import { Component, Input, Output, Inject, EventEmitter, ViewChild, DOCUMENT } from '@angular/core';

import { GenericService } from '../../../../../../common/common.service';
import { ConsoleLoggerService } from '../../../../../../common/LoggerService/console-logger.service';
import { CounterpartyLimitViewModel, TradingCounterpartyLimit } from '../../CounterpartyLimits.component.model';
import { retry } from 'rxjs/operators';
import { DxDataGridComponent } from 'devextreme-angular';
import { DatePickerService } from '../../../../../../common/date-picker/date-picker.service';
import { UtilityService } from '../../../../../../common/utility.service';

@Component({
    selector: 'app-ReviewDate',
    templateUrl: './ReviewDate.component.html',
    styleUrls: ['./ReviewDate.component.css'],
    standalone: false
})
export class ReviewDateComponent {
  @Input() __oCounterpartyLimits: CounterpartyLimitViewModel[];
  @Output() getReviewDateUpdated = new EventEmitter<any>();
  @Output() getReviewDateUpdateCancelled = new EventEmitter<any>();
  public __oTradingCounterpartyLimits: TradingCounterpartyLimit[]=[];
  public __sPortalDateFormat: string;
  public __sPortalDateTimeFormat: string;
  public __sPortalFromToDateFormat: string = 'MMM-yyyy';//43617 - Pawan Prajapati
  public CompositeKey: string[] = ["lTradingCounterpartyId", "lOurEntityId", "lLimitTypeId"];
  @ViewChild("dgSetDates") __oDGSetDates: DxDataGridComponent;
  constructor(@Inject(DOCUMENT) private document: any, public service: GenericService, private Logger: ConsoleLoggerService, public datePickerService: DatePickerService, public __oUtilityService: UtilityService) {
  }
  //fires on Ok button click
  btnApply_Click() {
    this.getReviewDateUpdated.emit(this.__oCounterpartyLimits);
  }
  //fires on cancel button click
  btnCancel_Click() {
    this.getReviewDateUpdateCancelled.emit(false);
  }
  // forms limits into exposure overall limits to set review dates
  public formTradingCounterpartyLimit() {
    try {
      if (this.__oCounterpartyLimits != undefined && this.__oCounterpartyLimits != null) {
        this.__oTradingCounterpartyLimits = [];

        for (var oCounterpartyLimit of this.__oCounterpartyLimits.filter(x => x.lTradingCategoryId == 1 && x.lSubLimitTypeId == 3)) {
          if (oCounterpartyLimit.TradingCounterpartyLimit != null) {
            let oTradingCounterpartyLimit: TradingCounterpartyLimit = new TradingCounterpartyLimit();

            oTradingCounterpartyLimit.lTradingCounterpartyId = oCounterpartyLimit.TradingCounterpartyLimit.lTradingCounterpartyId;            
            oTradingCounterpartyLimit.lOurEntityId = oCounterpartyLimit.TradingCounterpartyLimit.lOurEntityId;
            oTradingCounterpartyLimit.lTradingCategoryId = 1;
            oTradingCounterpartyLimit.lLimitTypeId = oCounterpartyLimit.TradingCounterpartyLimit.lLimitTypeId;
            oTradingCounterpartyLimit.IsAutoRollOver = oCounterpartyLimit.TradingCounterpartyLimit.IsAutoRollOver;
            oTradingCounterpartyLimit.EntityState = oTradingCounterpartyLimit.EntityState == 1 ? 1 : oCounterpartyLimit.TradingCounterpartyLimit.EntityState;
            oTradingCounterpartyLimit.StartDate = oCounterpartyLimit.TradingCounterpartyLimit.StartDate;
            oTradingCounterpartyLimit.EndDate = oCounterpartyLimit.TradingCounterpartyLimit.EndDate;
            oTradingCounterpartyLimit.From = typeof (oCounterpartyLimit.From) == 'string' ? new Date(oCounterpartyLimit.From) : oCounterpartyLimit.From;//FB43617-Pawan Prajapati
            oTradingCounterpartyLimit.To = typeof (oCounterpartyLimit.To) == 'string' ? new Date(oCounterpartyLimit.To) : oCounterpartyLimit.To;//FB43617-Pawan Prajapati
            oTradingCounterpartyLimit.NextReviewDate = oCounterpartyLimit.TradingCounterpartyLimit.NextReviewDate ? this.transformDate(new Date(oCounterpartyLimit.TradingCounterpartyLimit.NextReviewDate)) : null;;
            oTradingCounterpartyLimit.LastReviewDate = oCounterpartyLimit.TradingCounterpartyLimit.LastReviewDate ? this.transformDate(new Date(oCounterpartyLimit.TradingCounterpartyLimit.LastReviewDate)) : null;
            oTradingCounterpartyLimit.lTradingCounterpartyLimitId = oCounterpartyLimit.TradingCounterpartyLimit.lTradingCounterpartyLimitId;

            oTradingCounterpartyLimit.TradingCounterpartyName = oCounterpartyLimit.TradingCounterpartyName;
            oTradingCounterpartyLimit.TradingEntityName = oCounterpartyLimit.TradingEntityName;
            oTradingCounterpartyLimit.LimitTypeName = oCounterpartyLimit.LimitTypeName;
            oTradingCounterpartyLimit.IsEntityRestricted = oCounterpartyLimit.IsEntityRestricted;
            oTradingCounterpartyLimit.IsReadonlyAccess = oCounterpartyLimit.IsReadonlyAccess;
            oTradingCounterpartyLimit.IsTradingCounterpartyInstanceSaveAccess = oCounterpartyLimit.IsTradingCounterpartyInstanceSaveAccess;
            this.__oTradingCounterpartyLimits.push(oTradingCounterpartyLimit);
          }
          else {
            let oTradingCounterpartyLimit: TradingCounterpartyLimit = new TradingCounterpartyLimit();

            oTradingCounterpartyLimit.lTradingCounterpartyId = oCounterpartyLimit.lTradingCounterpartyId;
            oTradingCounterpartyLimit.lOurEntityId = oCounterpartyLimit.lOurEntityId;
            oTradingCounterpartyLimit.lTradingCategoryId = 1;
            oTradingCounterpartyLimit.lLimitTypeId = oCounterpartyLimit.lLimitTypeId;
            oTradingCounterpartyLimit.IsAutoRollOver = false;
            oTradingCounterpartyLimit.EntityState = 1;
            oTradingCounterpartyLimit.StartDate = new Date();
            oTradingCounterpartyLimit.EndDate = new Date();
            oTradingCounterpartyLimit.From = typeof (oCounterpartyLimit.From) == 'string' ? new Date(oCounterpartyLimit.From) : oCounterpartyLimit.From;//FB43617-Pawan Prajapati
            oTradingCounterpartyLimit.To = typeof (oCounterpartyLimit.To) == 'string' ? new Date(oCounterpartyLimit.To) : oCounterpartyLimit.To;//FB43617-Pawan Prajapati
            oTradingCounterpartyLimit.NextReviewDate = null;
            oTradingCounterpartyLimit.LastReviewDate = null;
            oTradingCounterpartyLimit.lTradingCounterpartyLimitId = 0;

            oTradingCounterpartyLimit.TradingCounterpartyName = oCounterpartyLimit.TradingCounterpartyName;
            oTradingCounterpartyLimit.TradingEntityName = oCounterpartyLimit.TradingEntityName;
            oTradingCounterpartyLimit.LimitTypeName = oCounterpartyLimit.LimitTypeName;
            oTradingCounterpartyLimit.IsEntityRestricted = oCounterpartyLimit.IsEntityRestricted;
            oTradingCounterpartyLimit.IsReadonlyAccess = oCounterpartyLimit.IsReadonlyAccess;
            oTradingCounterpartyLimit.IsTradingCounterpartyInstanceSaveAccess = oCounterpartyLimit.IsTradingCounterpartyInstanceSaveAccess;

            this.__oTradingCounterpartyLimits.push(oTradingCounterpartyLimit);
          }
        }
      }
    } catch (e) {
      this.Logger.Write(e, "Error", "btnSetDatesClick_LimitsComponent");
    }
  }
  //Transforms Limits into exposure over all limits 
  public transformTradingCounterpartyLimit(__oDataSource: CounterpartyLimitViewModel[]): CounterpartyLimitViewModel[] {
    try {
      for (var oTradingcounterpartyLimit of this.__oTradingCounterpartyLimits) {
        let oCounterpartyLimit: CounterpartyLimitViewModel = __oDataSource.find(x => x.lTradingCategoryId == 1 && x.lSubLimitTypeId == 3 && x.lTradingCounterpartyId == oTradingcounterpartyLimit.lTradingCounterpartyId && x.lOurEntityId == oTradingcounterpartyLimit.lOurEntityId && x.lLimitTypeId == oTradingcounterpartyLimit.lLimitTypeId);

        if (oCounterpartyLimit != null) {
          if (oCounterpartyLimit.TradingCounterpartyLimit == null) {
            oCounterpartyLimit.TradingCounterpartyLimit = oTradingcounterpartyLimit;
            oCounterpartyLimit.TradingCounterpartyLimit.NextReviewDate = oTradingcounterpartyLimit.NextReviewDate ? this.transformDate(new Date(oTradingcounterpartyLimit.NextReviewDate)) : null;
            oCounterpartyLimit.TradingCounterpartyLimit.LastReviewDate = oTradingcounterpartyLimit.LastReviewDate ? this.transformDate(new Date(oTradingcounterpartyLimit.LastReviewDate)) : null;
          }
          else {
            oCounterpartyLimit.TradingCounterpartyLimit.lTradingCounterpartyId = oTradingcounterpartyLimit.lTradingCounterpartyId;
            oCounterpartyLimit.TradingCounterpartyLimit.lOurEntityId = oTradingcounterpartyLimit.lOurEntityId;
            oCounterpartyLimit.TradingCounterpartyLimit.lTradingCategoryId = 1;
            oCounterpartyLimit.TradingCounterpartyLimit.lLimitTypeId = oTradingcounterpartyLimit.lLimitTypeId;
            oCounterpartyLimit.TradingCounterpartyLimit.IsAutoRollOver = oTradingcounterpartyLimit.IsAutoRollOver;
            oCounterpartyLimit.TradingCounterpartyLimit.EntityState = oTradingcounterpartyLimit.EntityState;
            oCounterpartyLimit.TradingCounterpartyLimit.StartDate = oTradingcounterpartyLimit.StartDate;
            oCounterpartyLimit.TradingCounterpartyLimit.EndDate = oTradingcounterpartyLimit.EndDate;
            oCounterpartyLimit.TradingCounterpartyLimit.NextReviewDate = oTradingcounterpartyLimit.NextReviewDate ? this.transformDate(new Date(oTradingcounterpartyLimit.NextReviewDate)) : null;
            oCounterpartyLimit.TradingCounterpartyLimit.LastReviewDate = oTradingcounterpartyLimit.LastReviewDate ? this.transformDate(new Date(oTradingcounterpartyLimit.LastReviewDate)) : null;
            oCounterpartyLimit.TradingCounterpartyLimit.lTradingCounterpartyLimitId = oTradingcounterpartyLimit.lTradingCounterpartyLimitId;
          }

        }
      }
    } catch (e) {
      this.Logger.Write(e, "Error", "btnPopUpOKClick_LimitsComponent");
    }
    return __oDataSource;
  }
  ///transforms dates into GMT
  transformDate(__dtDate:any) {
    let dt;
    dt = this.__oUtilityService.toLocalISODate(new Date(__dtDate)); 
    return dt;
  }
  //fires on editor preparing
  onEditorPreparing(e: any) {
    try {
      this.datePickerService.onEditorPreparingMethod(e);
      if (e.row && e.row.data) {
        e.row.data.EntityState = 2;
      }
      if (e.dataField === 'EndDate' && e.row && e.row.data && e.row.data.IsAutoRollOver == true) {
        e.editorOptions.disabled = true;
      }
      else {
        e.editorOptions.disabled = false;
      }

      e.editorOptions.readOnly = e.parentType == "dataRow" && e.dataField == "User";
    } catch (e) {
      this.Logger.Write(e, "Error", "onEditorPreparingForDateSetGrid_LimitsComponent");
    }
  };
  //fires on initialisation of component
  ngOnInit() {
    //To handle  Date format in Portal 
    this.__sPortalDateFormat = sessionStorage.getItem('PortalDateFormat');
    this.__sPortalDateTimeFormat = sessionStorage.getItem('PortalDateFormat') + " HH:mm:ss";
  }
  //FB43617-Pawan Prajapati
  onDateValueChanged(oTradingCounterpartyLimit, oInfo, event?: any) {
    if (event) {
      oTradingCounterpartyLimit[oInfo.column.dataField] = event.value;
    }
    oTradingCounterpartyLimit[oInfo.column.dataField] = oTradingCounterpartyLimit[oInfo.column.dataField] ? this.transformDate(new Date(oTradingCounterpartyLimit[oInfo.column.dataField])) : null;
  }
  //fires  on while row is prepared
  onRow_Prepared(evnt: any) {
    try {      
      if (evnt.rowType === 'data') {        
        if (evnt.data.IsEntityRestricted) {
          evnt.rowElement.style.pointerEvents = 'none';
          evnt.rowElement.hidden = true;
        }
        if (evnt.data.IsReadonlyAccess || !evnt.data.IsTradingCounterpartyInstanceSaveAccess) {
          evnt.rowElement.style.pointerEvents = 'none';
        }
      }
    } catch (e) {
      this.Logger.Write(e, 'Error', 'Error occurred while preparing row.');
    }
  }
  isEntityRestrictedRow(Info) {
    if (!Info.data.IsTradingCounterpartyInstanceSaveAccess) {
      return true;
    }
    return Info.data.IsReadonlyAccess;
  }
}
